import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { dateToString } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

//Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import Form from "~/common/components/Form";
import Textarea from "~/common/components/textarea";
import useAlert from "~/common/hooks/useAlert";

//Assets
import "~/assets/sass/pages/portfolio/portfolioEdit.scss";

//Pages
import BasicInfo from "../BasicInfo";
import StartupInvests from "../StartupInvests";
import StartupProducts from "../StartupProducts";

export const STEP_OPTIONS = [
	{ label: "PreSeed", value: "1" },
	{ label: "Seed", value: "2" },
	{ label: "PreSeries", value: "3" },
	{ label: "SeriesA", value: "4" },
	{ label: "SeriesB", value: "5" },
	{ label: "SeriesC", value: "6" },
	{ label: "SeriesD", value: "7" },
	{ label: "SeriesE", value: "8" },
	{ label: "M&A", value: "9" },
	{ label: "PreIPO", value: "10" },
	{ label: "IPO", value: "11" },
];

const CommonEditView = ({ portfolio = {}, industryOptions = [], onSave }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const portfolioBasicEditForm = useForm({
		defaultValues: {
			vcInvests: [],
			vcWithdraws: [],
			startupInvests: [],
			startupProducts: [],
			round: "1",
			investStatus: "계획없음",
		},
	});

	const checkValidation = (data) => {
		const { startupProducts } = data;
		let titleErrorIndex;
		if (startupProducts?.length > 0) {
			startupProducts.forEach((sp, index) => {
				if (!sp.title) {
					titleErrorIndex = index.toString();
					return false;
				}
			});
		}
		if (titleErrorIndex) {
			portfolioBasicEditForm.setFocus(`startupProducts.${titleErrorIndex}.title`);
			return false;
		}
		return true;
	};

	const handleClickSaveBtn = (data) => {
		// debugger;
		// return;
		// portfolioBasicEditForm.setFocus('startupProducts.0.title')
		const {
			logoSqu,
			name,
			regNum,
			corpNum,
			ceoName,
			industryCondition,
			introduction,
			estDate,
			employeeNum,
			industry,
			portfolioKeyword,
			round,
			investStatus,
			comValue,
			target,
			address,
			addressDetail,
			homepage,
			vcInvests,
			vcWithdraws,
			startupInvests,
			startupProducts,
		} = data;

		if (!checkValidation(data)) return;
		// debugger;

		let formData = {
			// logoSqu,
			name,
			// regNum,
			// corpNum,
			ceoName,
			industryCondition,
			introduction,
			// zipCode
			address,
			addressDetail,
			estDate: dateToString(estDate, "yyyy-MM-dd"),
			employeeNum,
			// industry
			round,
			investStatus,
			comValue,
			// target,
			homepage,
			StartupKeyword: [...(portfolioKeyword || [])],
			// StartupProduct: [...startupProducts]
			// VcInvest: [...vcInvests]
		};
		if (regNum) {
			formData["regNum"] = typeof regNum === "number" ? regNum.toString() : regNum;
		}
		if (corpNum) {
			formData["corpNum"] = typeof corpNum === "number" ? corpNum.toString() : corpNum;
		}
		if (comValue) {
			formData["comValue"] = typeof comValue === "number" ? comValue.toString() : comValue;
		}
		if (target) {
			formData["target"] = typeof target === "number" ? target.toString() : target;
		}
		if (logoSqu?.length > 0) {
			formData["logoSqu"] = logoSqu[0];
		}

		if (industry) {
			formData["Industry"] = industry.map((i) => i.idx);
		}
		if (vcInvests) {
			formData["VcInvest"] = vcInvests.map((v) => {
				const { createDate, deleteDate, updateDate, comValue, value, date, ...rest } = v;
				return {
					...rest,
					comValue: !!comValue ? comValue : 0,
					value: typeof value === "number" ? value?.toString() : value,
					date: dateToString(new Date(date), "yyyy-MM-dd"),
				};
			});
		}
		if (vcWithdraws) {
			formData["VcWithdraw"] = vcWithdraws.map((v) => {
				const { createDate, deleteDate, updateDate, value, withdrawDate, ...rest } = v;
				return {
					...rest,
					value: typeof value === "number" ? value?.toString() : value,
					withdrawDate: dateToString(new Date(withdrawDate), "yyyy-MM-dd"),
				};
			});
		}
		if (startupInvests) {
			formData["StartupInvest"] = startupInvests.map((v) => {
				const { createDate, deleteDate, updateDate, value, comValue, date, ...rest } = v;
				return {
					...rest,
					value: typeof value === "number" ? value?.toString() : value,
					comValue: typeof comValue === "number" ? comValue.toString() : comValue,
					date: dateToString(new Date(date), "yyyy-MM-dd"),
				};
			});
		}
		if (startupProducts) {
			formData["StartupProduct"] = startupProducts.map((v) => {
				const { createDate, deleteDate, updateDate, Image, Keyword, ...rest } = v;
				return {
					...rest,
				};
			});
		}
		onSave && onSave(formData);
	};

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="gray"
			onClick={() => {
				showModifyAlert(true).then(() => {
					navigate(-1);
				});
			}}
		>
			{t("pages.portfolio.PortfolioEdit.components.CommonEditView.cancel")}
		</button>,
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={portfolioBasicEditForm.handleSubmit(handleClickSaveBtn)}
		>
			{t("pages.portfolio.PortfolioEdit.components.CommonEditView.save")}
		</button>,
	];
	const [showModifyAlert, ModifyAlert] = useAlert();

	useEffect(() => {
		if (!portfolio.idx) return;
		const {
			VcInvest,
			VcWithdraw,
			StartupInvest,
			StartupProduct,
			round,
			step,
			investStatus,
			StartupIndustry,
			StartupKeyword,
			logoSqu,
			...rest
		} = portfolio;
		let defaultValues = {
			...rest,
			vcInvests: VcInvest?.length > 0 ? VcInvest : [],
			vcWithdraws: VcWithdraw?.length > 0 ? VcWithdraw : [],
			startupInvests: StartupInvest?.length > 0 ? StartupInvest : [],
			portfolioKeyword: StartupKeyword?.length > 0 ? StartupKeyword.map((v) => v.title) : [],
			round: round || "1",
			investStatus:
				investStatus ||
				t("pages.portfolio.PortfolioEdit.components.CommonEditView.onGoing"),
			logoSqu: logoSqu ? [logoSqu] : undefined,
		};
		if (StartupIndustry?.length > 0) {
			const tmpIndustryArr = StartupIndustry.map((si) => {
				const { name, idx } = si.IndustryKeywords;
				return {
					idx,
					name,
				};
			});
			defaultValues = {
				...defaultValues,
				industry: tmpIndustryArr,
			};
		}
		if (StartupProduct?.length > 0) {
			const tmpArr = StartupProduct.map((sp) => {
				const t = {
					...sp,
					keyword: sp.Keyword.map((k) => k.title),
					image: sp.Image.map((k) => k.imgUrl),
				};
				return t;
			});

			defaultValues = {
				...defaultValues,
				startupProducts: tmpArr,
			};
		}
		portfolioBasicEditForm.reset(defaultValues);
	}, [portfolio]);

	return (
		<>
			<NavbarAndSidebarLayout menu={["portfolio", "edit"]} type={"main"}>
				<PageHeader buttonList={headerButtons} />
				<div className="c__card card-portfolio-edit">
					<div className="portfolio-common-wrap">
						<section className="basic-info-section">
							<BasicInfo
								useForm={portfolioBasicEditForm}
								industryOptions={industryOptions}
							/>
						</section>
						<section className="detail-info-section">
							<ul className="detail-info-wrap">
								<StartupInvests useForm={portfolioBasicEditForm} />
								<li className="detail-info-item">
									<div className="title-group">
										<h4 className="detail-info-title">
											{t(
												"pages.portfolio.PortfolioEdit.components.CommonEditView.introCompany"
											)}
										</h4>
									</div>
									<Form useForm={portfolioBasicEditForm}>
										<Textarea
											name="introduction"
											maxLength={450}
											showCount={true}
										/>
									</Form>
								</li>
								<StartupProducts useForm={portfolioBasicEditForm} />
							</ul>
						</section>
					</div>
				</div>
			</NavbarAndSidebarLayout>

			{/*취소 버튼 눌렀을때 모달*/}
			<ModifyAlert
				type="warning"
				layout="horiz"
				message={
					<>
						<h3>
							{t("pages.portfolio.PortfolioEdit.components.CommonEditView.cancelMod")}
						</h3>
						<p>
							{t("pages.portfolio.PortfolioEdit.components.CommonEditView.dontSave")}
						</p>
					</>
				}
				reject={t("pages.portfolio.PortfolioEdit.components.CommonEditView.non")}
				confirm={t("pages.portfolio.PortfolioEdit.components.CommonEditView.yes")}
				height={230}
			/>
		</>
	);
};

export default CommonEditView;
